import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    getProductMarkerNormalAsync,
    getProductMarkerHoverAsync,
    getVideoMarkerNormalAsync,
    spotifyModalHotspotIds
} from '../../utils/StaticAssetManager.js';
import Marker from './Marker.jsx';
import ComposableModal from '../ui/modals/composable/ComposableModal.jsx';
import ImageCarouselModal from '../ui/modals/image-carousel/ImageCarouselModal';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager.js';
import { getIconSVGAsync } from '../ui/ui-layer-panel/SVGIcons.jsx';
import TextModal from '../ui/modals/text/TextModal';
import { ModalTypes } from '../ui/modals/utils/ModalConstants';
const customVideoCarouselId = '623af9ffe0213a2d3229806c';
import VideoCarouselModal from '../ui/modals/video-carousel/VideoCarouselModal';
import HeritageCarouselModal from '../ui/modals/heritage-carousel/HeritageCarouselModal';
import SpotifyPlayerModal from '../ui/modals/spotify-player-modal/SpotifyPlayerModal.jsx';
import { AppContext } from '../../AppContext.jsx';

export const ModalMarkerTypes = Object.freeze({
    Image: "image",
    ImageCarousel: "image_carousel",
    Video: "video",
    TextWithButton: "text_with_button"
});

export const MarkerImageAssets = Object.freeze({
    VideoMarker: "https://cdn.obsess-vr.com/play-icon.svg",
    ImageMarker: "https://cdn.obsess-vr.com/vacheron/template-image-hotspot-icon-v1.svg",
    ImageCarouselMarker: "https://cdn.obsess-vr.com/vacheron/template-image-hotspot-icon-v1.svg",
    SpotifyMusicMarker: "https://cdn.obsess-vr.com/vacheron/vac-music-icon-v1.svg",
    DiscoverUrl: "https://cdn.obsess-vr.com/vacheron/Discover-v2.svg",
    PhoneUrl: "https://cdn.obsess-vr.com/vacheron/Phone-v2.svg"
});
const heritageCarouselId = new Set(['60e871dbc584ff71d102bf0f','60e880b9c584ff71d102bf10','60e880b9c584ff71d102bf11','60e880b9c584ff71d102bf12','60f00faef2e43cc4d45f6f63']);    

class ModalMarker extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);

        this.state = {
            isShowingModal: false,
            normalSpriteUrl: '',
            hoverSpriteUrl: '',
            svgSprite: null,
            svgSpriteString: ''
        };
        this.mounted = false;
    }

    setSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
        .then(svgString => this.setState({ svgSpriteString: svgString }))
        .catch(error => console.error(error));
    }

    componentDidMount() {
        this.mounted = true;
        switch (this.props.type) {
            case ModalMarkerTypes.Video:
                if(spotifyModalHotspotIds.includes(this.props.hotspotId)){
                    this.setSVGIcon(MarkerImageAssets.SpotifyMusicMarker);
                }else{
                    this.setSVGIcon(MarkerImageAssets.VideoMarker);
                }
                break;
            case ModalMarkerTypes.Image:
                // TODO: import web-store-modules for svgs.
                this.setSVGIcon(MarkerImageAssets.ImageMarker);
                break;
            case ModalMarkerTypes.ImageCarousel:              
                this.setSVGIcon(MarkerImageAssets.ImageCarouselMarker);
                break;
            case ModalMarkerTypes.TextWithButton:
                if(this.props.hotspotId === '623aec4f312bce15cb8a4a7b') {
                    this.setState({ normalSpriteUrl: MarkerImageAssets.PhoneUrl, hoverSpriteUrl: MarkerImageAssets.PhoneUrl });
                } else {
                    this.setState({ normalSpriteUrl: MarkerImageAssets.DiscoverUrl, hoverSpriteUrl: MarkerImageAssets.DiscoverUrl });
                }
                break;
            default:
                getProductMarkerNormalAsync()
                .then(url => this.setState({ normalSpriteUrl: url }))
                .catch(error => console.error(error));
                getProductMarkerHoverAsync()
                .then(url => this.setState({ hoverSpriteUrl: url }))
                .catch(error => console.error(error));
                getHotspotIconStyle()
                .then(icon => {
                    const Sprite = icon == 'blank' ? HotspotCircle : HotspotPlus;
                    this.setState({ svgSprite: Sprite });
                })
                .catch(error => console.error(error));
                break;
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onClick() {
        console.log(this.props.hotspotId,'this.props.hotspotId<<<')
        if(spotifyModalHotspotIds.includes(this.props.hotspotId))
            this.props.setSpotifyModalVisibility(true);

        if (!this.mounted) {
            return;
        }
        
        this.setState({ isShowingModal: true });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: false });
    }

    getTextModal() {
        if(heritageCarouselId.has(this.props.hotspotId)){
            return (
                <HeritageCarouselModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    hotspotId={this.props.hotspotId}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            );
        }else if(spotifyModalHotspotIds.includes(this.props.hotspotId)){
            return null;
        }
        else {
            return (
                <TextModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    hotspotId={this.props.hotspotId}
                />
            );
        }
    }

    getComposableModal() {
        return (
            <ComposableModal
                type={this.props.type}
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
            />
        );
    }

    getImageCarouselModal() {
        console.log('getImageCarouselModal')
        if(heritageCarouselId.has(this.props.hotspotId)){
            return (
                <HeritageCarouselModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    hotspotId={this.props.hotspotId}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            );
        }else if(this.props.secneHotspotId == customVideoCarouselId){
            return (
                <VideoCarouselModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            )
        } else {
            return (
                <ImageCarouselModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    hotspotId={this.props.hotspotId}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            );
        }        
    }

    renderModal() {
        if (this.state.isShowingModal && this.props.type) {
            switch (this.props.type) {
                case ModalTypes.TextModal:
                    return this.getTextModal();
                case ModalTypes.ImageCarousel:
                    return this.getImageCarouselModal();
                default:
                    return this.getComposableModal();
            }
        }
        return null;
    }

    render() {
        const { normalSpriteUrl, hoverSpriteUrl, svgSprite, svgSpriteString } = this.state;
        return (
            <div>
                {this.renderModal()}
                <Marker
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    normalSpriteUrl={normalSpriteUrl}
                    hoverSpriteUrl={hoverSpriteUrl}
                    svgSprite={svgSprite}
                    svgSpriteString={svgSpriteString}
                    showVisual={this.props.showVisual}
                    onClick={this.onClick}
                    primaryColor="#7C2529"
                    secondaryColor="#7C2529"
                />
            </div>
        );
    }
}

ModalMarker.propTypes = {
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    modalContent: PropTypes.object.isRequired,
    showVisual: PropTypes.bool,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secneHotspotId: PropTypes.string,
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ModalMarker
                {...props}
                setSpotifyModalVisibility={appContextValue.setSpotifyModalVisibility}
            />
         )}     
    </AppContext.Consumer>
);